import { EuiCollapsibleNavBeta } from "@inscopix/ideas-eui";
import { useRouteMapContext } from "providers/RouteMapProvider/RouteMapProvider";
import { memo } from "react";

export const HeaderNavHome = memo(function HeaderNavHome() {
  const routeMap = useRouteMapContext((s) => s.routeMap);

  return (
    <EuiCollapsibleNavBeta.Item
      title="Home"
      icon="home"
      onClick={() => {
        // Navigate to the home page
        routeMap["DASHBOARD"].navigateTo();
      }}
    />
  );
});
